export default __webpack_public_path__ + "static/media/programploadImage.d2050a81.png";